import { axiosInstance } from "./axiosInstance";

// 고객용 활성 배너 목록 조회
export const getActiveBanners = async (bannerType?: string) => {
    try {
        const params = bannerType ? { bannerType } : {};
        const response = await axiosInstance.get(`/api/banners`, { params });
        return response.data;
    } catch (error) {
        console.error("배너 목록 조회 에러:", error);
        return { data: [] }; // 에러 시 빈 배열 반환하여 화면 깨짐 방지
    }
};